import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import userManagementAPI from '../apis/userManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class UserManagementStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    roleId: '',
    status: '',
    searchText: '',
  }
  @observable userList = []
  @action
  async onSearchUserAction(params,pageNo,pageSize) {
    this.isFetching = true
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      this.userList = []
      this.searchItem = params
      const response = await userManagementAPI.searchAction(params,pageNo,pageSize)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          for (let i = 0; i < response.data.data?.content.length; i++) {
            response.data.data.content[i]?.status?response.data.data.content[i].statusName='Enable': response.data.data.content[i].statusName='Disable';
            response.data.data.content[i].rolesList = response.data.data.content[i]?.roles.map((item,index)=>{
              return index===response.data.data.content[i].roles.length-1?item.name:item.name+', '
            })
            response.data.data.content[i]?.powerUser?response.data.data.content[i].powerUser='true':response.data.data.content[i].powerUser='false'
          }
          this.userList = response.data.data?.content || []
          this.itemCount = response.data.data?.totalElements
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  @action
  onChangeUserList(value){
    this.userList=value
  }
  /*add user*/
  @action
  async onAddUserAction(params){
    this.isFetching = true
    try {
      const response = await userManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchUserAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Add Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*get role list*/
  @observable userRoleList = []
  @action
  async getRoleAction(){
    try {
      const response = await userManagementAPI.getRoleAction()
      runInAction(() => {
        if (response.data.code === 0) {
          response.data.data.filter(item=>item.status).map(it => {
            return this.userRoleList.push(it)
          })
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  emptyUserRoleList(value) {
    this.userRoleList=value
  }
  //change targetKeys
  @observable targetKeys = [];
  @action
  getRoleUserTargetKeys(value) {
    this.targetKeys=value
  }
  /*add user role*/
  @action
  async onAddRoleAction(params,id){
    this.isFetching = true
    try {
      const response = await userManagementAPI.roleAction(params,id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          this.onSearchUserAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*change status*/
  @action
  async onChangeStatus(params,id){
    this.isFetching = true
    try {
      const response = await userManagementAPI.statusAction(params,id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          this.onSearchUserAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  // 修改密码
  @action
  async onUpdatePwdBySystem(params) {
    this.isFetching = true
    try {
      const response = await userManagementAPI.updatePwdBySystem(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchUserAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Add Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchUserAction(this.searchItem,this.pageNo,this.pageSize)
  }
  @action
  onChangePageNo(){
    this.pageNo = 1;
  }
  // 查询密码
  @observable passwordData = null
  @action
  async onSearchPassword() {
    this.isFetching = true
    try {
      const response = await userManagementAPI.searchPassword()
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.passwordData = response.data.data
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
      alertMessage.error('处理异常！'+err.message)
    }
  }
  @action
  onClearPassword() {
    this.passwordData = null
  }
  // 生成密码
  @action
  async onGeneratePassword(params) {
    this.isFetching = true
    try {
      const response = await userManagementAPI.generatePassword(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Generate Success！')
          this.onSearchUserAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Generate Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
